export const SET_CURRENTMAPVIEW = "[current mapView] set current map view";

export const setCurrentMapView = mapView => {
  return {
    type: SET_CURRENTMAPVIEW,
    payload: mapView
  };
};
